import { ColetaFluxoLemit } from '../../types/coleta';
import { AVISO_LEMIT_PENDENTE, AVISO_LEMIT_QUANDO_ASSINADO } from './coletaFluxoTexto';
import { chaveTelefoneBr } from './coletaResumoQualidade';

function digitos(valor?: string | null): string {
  return (valor || '').replace(/\D/g, '');
}

function telefoneUtil(valor?: string | null): string {
  const numero = digitos(valor);
  const chave = chaveTelefoneBr(numero);
  return chave.length >= 10 && chave.length <= 11 ? numero : '';
}

export function numerosDoLemit(
  lemit?: ColetaFluxoLemit | null,
  telefoneLemit?: string | null,
): string[] {
  const saida: string[] = [];
  const vistos = new Set<string>();
  const incluir = (valor?: string | null) => {
    const numero = telefoneUtil(valor);
    const chave = chaveTelefoneBr(numero);
    if (!numero || !chave || vistos.has(chave)) return;
    vistos.add(chave);
    saida.push(numero);
  };
  (lemit?.telefones ?? []).forEach((item) => incluir(item?.numero));
  incluir(telefoneLemit);
  return saida;
}

export function temDadoLemit(lemit?: ColetaFluxoLemit | null): boolean {
  return Boolean(
    (lemit?.dados ?? []).some((item) => (item.campo || '').trim() || (item.valor || '').trim())
    || (lemit?.telefones ?? []).some((item) => (item.numero || '').trim())
    || (lemit?.socios ?? []).some((item) => (item.nome || '').trim() || (item.cpf || '').trim()),
  );
}

export function temResultadoLemit(
  lemit?: ColetaFluxoLemit | null,
  telefoneLemit?: string | null,
): boolean {
  return lemit != null || Boolean((telefoneLemit || '').trim());
}

export function lemitParaTela(
  lemit?: ColetaFluxoLemit | null,
  telefoneLemit?: string | null,
): ColetaFluxoLemit | null {
  if (lemit != null) return lemit;
  const numero = (telefoneLemit || '').trim();
  if (!numero) return null;
  return { telefones: [{ numero }] };
}

export function mostrarSecaoLemit(adminEncontradoNoP2b: boolean): boolean {
  return !adminEncontradoNoP2b;
}

export function textoVazioLemit(entrada: {
  temResultadoLemit: boolean;
  lemitAindaEsperado: boolean;
  assinadoOuDepois: boolean;
}): string {
  if (entrada.temResultadoLemit) return 'Ainda não há dados do Lemmit.';
  if (!entrada.lemitAindaEsperado) return 'Ainda não há dados do Lemmit.';
  return entrada.assinadoOuDepois ? AVISO_LEMIT_PENDENTE : AVISO_LEMIT_QUANDO_ASSINADO;
}
